<template>
  <el-select
    v-if="!useVuetify"
    size="small"
    placeholder="Please select an email"
    @change="doChange"
    v-model="internalValue"
    filterable
  >
    <el-option
      v-for="option in getVerifiedEmails"
      :value="option.id"
      :label="option.value"
      :key="option.id"
    />
  </el-select>

  <v-select
    v-else
    v-model="internalValue"
    :items="getVerifiedEmails"
    item-value="id"
    item-title="value"
    :label="label"
    :placeholder="placeholder"
    :density="density"
    variant="outlined"
    hide-details
    @update:model-value="doChange"
  />
</template>
<script>
import companyServices from 'src/services/companyServices';

export default {
  name: 'emailFromSelect',
  props: {
    value: {
      type: Number,
    },
    modelValue: {
      type: Number,
    },
    useVuetify: {
      type: Boolean,
      default: false,
    },
    density: {
      type: String,
      default: 'compact',
      validator: (value) => ['comfortable', 'compact', 'default'].includes(value),
    },
    label: {
      type: String,
      default: 'From Email',
    },
    placeholder: {
      type: String,
      default: 'Please select an email',
    },
  },
  computed: {
    getVerifiedEmails() {
      return this.domains.filter((d) => d.type == 'email' && d.verified);
    },
  },
  data() {
    return {
      loading: true,
      internalValue: undefined,
      domains: [],
    };
  },
  watch: {
    value(n) {
      if (n !== undefined) {
        this.internalValue = parseInt(n);
      }
    },
    modelValue(n) {
      if (n !== undefined) {
        this.internalValue = parseInt(n);
      }
    },
  },
  async created() {
    await this.loadDomains();
    const val = this.modelValue || this.value;
    if (val) {
      this.internalValue = parseInt(val);
    }
  },
  methods: {
    async loadDomains() {
      await companyServices.checkDomains();
      const domains = await companyServices.listDomains('email');
      this.domains = domains.data;
    },
    doChange() {
      this.$emit('update:modelValue', this.internalValue);
      this.$emit('change', this.internalValue);
    },
  },
};
</script>
